import classNames from "@/utils/classNames";

type BadgeNumbersProps = {
    badgeNumbers: number[];
    badgeStyles?: string[];
};

export default function BadgeNumbers({
    badgeNumbers,
    badgeStyles = [],
}: BadgeNumbersProps) {
    return (
        <div className="flex">
            {badgeNumbers.map((number, index) =>
                number > 0 ? (
                    <div
                        key={index}
                        className={classNames(
                            "absolute flex h-4 w-4 items-center justify-center rounded-full text-xs font-bold",
                            badgeStyles[index] ?? "",
                        )}
                        style={{
                            zIndex: badgeNumbers.length - index,
                        }}
                    >
                        {number}
                    </div>
                ) : null,
            )}
        </div>
    );
}
